// extracted by mini-css-extract-plugin
module.exports = {"bcg":"ErrorBoundary_bcg__oVrFR","title":"ErrorBoundary_title__1R_Qc","redirectLink":"ErrorBoundary_redirectLink__1EowS"};